import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Logo, GoldButton, Input } from "@/components/ui-kit";

export default function ForgotPassword() {
  const [stage, setStage] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If that email exists, a reset code is on its way.");
      setStage(2);
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const reset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, code, new_password: newPassword });
      toast.success("Password reset! Log in with your new password.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#060D1F] flex flex-col" data-testid="forgot-password-page">
      <div className="px-5 sm:px-8 pt-6"><Logo /></div>
      <main className="flex-1 flex items-center justify-center px-5 py-14">
        <div className="w-full max-w-md fade-up">
          <h1 className="text-3xl sm:text-4xl text-white tracking-tight">Reset your password</h1>
          <p className="mt-3 text-slate-400">{stage === 1 ? "We'll email you a 6-digit reset code." : `Code sent to ${email}`}</p>
          {stage === 1 ? (
            <form onSubmit={sendCode} className="mt-9 space-y-5" data-testid="forgot-form">
              <Input data-testid="forgot-email-input" label="Email" type="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <GoldButton data-testid="send-code-button" type="submit" disabled={loading} className="w-full">{loading ? "Sending..." : "Send reset code"}</GoldButton>
            </form>
          ) : (
            <form onSubmit={reset} className="mt-9 space-y-5" data-testid="reset-form">
              <Input data-testid="reset-code-input" label="6-digit code" placeholder="123456" value={code} onChange={(e) => setCode(e.target.value)} required />
              <Input data-testid="new-password-input" label="New password" type="password" placeholder="6+ characters" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
              <GoldButton data-testid="reset-submit-button" type="submit" disabled={loading} className="w-full">{loading ? "Resetting..." : "Reset password"}</GoldButton>
            </form>
          )}
          <Link to="/login" data-testid="back-to-login-link" className="block mt-7 text-sm text-slate-400 transition-colors duration-300 hover:text-[#D4AF37]">Back to login</Link>
        </div>
      </main>
    </div>
  );
}
